import './Servicios.css';

export default function Privacidad() {
  return (
    <main className="servicios-page">
      <section className="page-hero">
        <div className="page-hero__bg"><div className="page-hero__orb" /></div>
        <div className="container page-hero__content">
          <div className="tag">Legal</div>
          <h1 className="page-hero__title">Política de<br /><span>Privacidad</span></h1>
          <p className="page-hero__sub">Última actualización: {new Date().toLocaleDateString('es-CO', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
        </div>
      </section>

      <section className="section" style={{paddingTop: 0}}>
        <div className="container">
          <div style={{maxWidth: 780, display: 'flex', flexDirection: 'column', gap: 40}}>

            <div>
              <h2 style={{fontFamily:'var(--font-display)', fontSize:22, fontWeight:500, color:'var(--aire)', marginBottom:12}}>1. Responsable del tratamiento</h2>
              <p style={{color:'var(--luz)', lineHeight:1.8, fontSize:15}}>
                KAIROS AI, operado por <strong style={{color:'var(--aire)'}}>MULTISISTEM RTV</strong>, con domicilio en Ibagué, Tolima, Colombia, es el responsable del tratamiento de los datos personales recopilados a través del sitio web <strong style={{color:'var(--onda)'}}>kairoslab.com.co</strong> y sus canales digitales asociados.
              </p>
              <p style={{color:'var(--luz)', lineHeight:1.8, fontSize:15, marginTop:10}}>
                Contacto: <a href="mailto:camilo@kairoslab.com.co" style={{color:'var(--onda)'}}>camilo@kairoslab.com.co</a>
              </p>
            </div>

            <div>
              <h2 style={{fontFamily:'var(--font-display)', fontSize:22, fontWeight:500, color:'var(--aire)', marginBottom:12}}>2. Marco legal</h2>
              <p style={{color:'var(--luz)', lineHeight:1.8, fontSize:15}}>
                El tratamiento de datos personales se rige por la <strong style={{color:'var(--aire)'}}>Ley 1581 de 2012</strong> (Ley de Protección de Datos Personales de Colombia), el Decreto 1377 de 2013 y demás normas concordantes. Al usar nuestros servicios, usted acepta las condiciones descritas en esta política.
              </p>
            </div>

            <div>
              <h2 style={{fontFamily:'var(--font-display)', fontSize:22, fontWeight:500, color:'var(--aire)', marginBottom:12}}>3. Datos que recopilamos</h2>
              <p style={{color:'var(--luz)', lineHeight:1.8, fontSize:15, marginBottom:12}}>Recopilamos los siguientes tipos de datos:</p>
              {[
                ['Datos de contacto', 'Nombre, correo electrónico, teléfono y empresa, cuando nos los proporciona voluntariamente a través del formulario de contacto o WhatsApp.'],
                ['Datos de navegación', 'Dirección IP, tipo de navegador, páginas visitadas y tiempo de permanencia, recopilados automáticamente para mejorar la experiencia del sitio.'],
                ['Datos de comunicación', 'Mensajes e información compartida en conversaciones con nuestros agentes IA o con nuestro equipo.'],
              ].map(([title, desc], i) => (
                <div key={i} style={{background:'rgba(127,119,221,0.05)', border:'1px solid rgba(127,119,221,0.14)', borderRadius:12, padding:'16px 20px', marginBottom:10}}>
                  <strong style={{color:'var(--aire)', fontSize:14}}>{title}</strong>
                  <p style={{color:'var(--luz)', fontSize:14, lineHeight:1.7, marginTop:6}}>{desc}</p>
                </div>
              ))}
            </div>

            <div>
              <h2 style={{fontFamily:'var(--font-display)', fontSize:22, fontWeight:500, color:'var(--aire)', marginBottom:12}}>4. Finalidad del tratamiento</h2>
              <p style={{color:'var(--luz)', lineHeight:1.8, fontSize:15, marginBottom:12}}>Sus datos son utilizados exclusivamente para:</p>
              {['Responder consultas y solicitudes de información.','Prestar los servicios contratados o solicitados.','Enviar comunicaciones comerciales relevantes (con su consentimiento).','Mejorar nuestros servicios y la experiencia del usuario.','Cumplir obligaciones legales y contractuales.'].map((item, i) => (
                <p key={i} style={{color:'var(--luz)', fontSize:14, lineHeight:1.7, paddingLeft:16}}>✦ {item}</p>
              ))}
            </div>

            <div>
              <h2 style={{fontFamily:'var(--font-display)', fontSize:22, fontWeight:500, color:'var(--aire)', marginBottom:12}}>5. Sus derechos</h2>
              <p style={{color:'var(--luz)', lineHeight:1.8, fontSize:15, marginBottom:12}}>De acuerdo con la Ley 1581 de 2012, usted tiene derecho a:</p>
              {[
                'Conocer, actualizar y rectificar sus datos personales.',
                'Solicitar prueba de la autorización otorgada.',
                'Ser informado sobre el uso de sus datos.',
                'Revocar la autorización y solicitar la supresión de sus datos.',
                'Presentar quejas ante la Superintendencia de Industria y Comercio (SIC).',
              ].map((item, i) => (
                <p key={i} style={{color:'var(--luz)', fontSize:14, lineHeight:1.7, paddingLeft:16}}>✦ {item}</p>
              ))}
              <p style={{color:'var(--luz)', lineHeight:1.8, fontSize:15, marginTop:14}}>
                Para ejercer estos derechos, escríbanos a <a href="mailto:camilo@kairoslab.com.co" style={{color:'var(--onda)'}}>camilo@kairoslab.com.co</a>. Responderemos en un plazo máximo de 15 días hábiles.
              </p>
            </div>

            <div>
              <h2 style={{fontFamily:'var(--font-display)', fontSize:22, fontWeight:500, color:'var(--aire)', marginBottom:12}}>6. Seguridad de los datos</h2>
              <p style={{color:'var(--luz)', lineHeight:1.8, fontSize:15}}>
                Implementamos medidas técnicas y organizativas para proteger sus datos contra acceso no autorizado, pérdida o divulgación indebida. Nuestro sitio utiliza cifrado HTTPS en todas sus comunicaciones.
              </p>
            </div>

            <div>
              <h2 style={{fontFamily:'var(--font-display)', fontSize:22, fontWeight:500, color:'var(--aire)', marginBottom:12}}>7. Cambios a esta política</h2>
              <p style={{color:'var(--luz)', lineHeight:1.8, fontSize:15}}>
                Nos reservamos el derecho de actualizar esta política. Cualquier cambio significativo será notificado a través de nuestro sitio web. Le recomendamos revisarla periódicamente.
              </p>
            </div>

            <div style={{background:'rgba(127,119,221,0.07)', border:'1px solid rgba(127,119,221,0.2)', borderRadius:16, padding:'24px 28px'}}>
              <p style={{color:'var(--aire)', fontSize:14, lineHeight:1.8}}>
                <strong>MULTISISTEM RTV · KAIROS AI</strong><br/>
                Ibagué, Tolima, Colombia<br/>
                📧 <a href="mailto:camilo@kairoslab.com.co" style={{color:'var(--onda)'}}>camilo@kairoslab.com.co</a><br/>
                🌐 kairoslab.com.co
              </p>
            </div>

          </div>
        </div>
      </section>
    </main>
  );
}
